import { DefaultObservableValue, isDefined, MutableObservableOption } from "@opendaw/lib-std";
import { AudioDevices } from "../AudioDevices";
const DEVICE_ID_KEY = "opendaw.mic-source.device-id";
const RECORD_CHANNELS_KEY = "opendaw.mic-source.record-channels";
const RECORD_GAIN_DB_KEY = "opendaw.mic-source.record-gain-db";
const hasLocalStorage = typeof localStorage !== "undefined";
const loadString = (key) => {
    if (!hasLocalStorage) {
        return undefined;
    }
    const raw = localStorage.getItem(key);
    return raw === null || raw.length === 0 ? undefined : raw;
};
const loadNumber = (key) => {
    if (!hasLocalStorage) {
        return undefined;
    }
    const raw = localStorage.getItem(key);
    if (raw === null) {
        return undefined;
    }
    const value = Number(raw);
    return isNaN(value) ? undefined : value;
};
const store = (key, value) => {
    if (!hasLocalStorage) {
        return;
    }
    if (!isDefined(value) || value.length === 0) {
        localStorage.removeItem(key);
    }
    else {
        localStorage.setItem(key, value);
    }
};
export var MicSource;
(function (MicSource) {
    MicSource.deviceId = new MutableObservableOption(loadString(DEVICE_ID_KEY));
    MicSource.recordChannels = new DefaultObservableValue(loadNumber(RECORD_CHANNELS_KEY) === 1 ? 1 : 2);
    MicSource.recordGainDb = new DefaultObservableValue(loadNumber(RECORD_GAIN_DB_KEY) ?? 0.0);
    MicSource.deviceId.subscribe(option => store(DEVICE_ID_KEY, option.unwrapOrUndefined()));
    MicSource.recordChannels.subscribe(owner => store(RECORD_CHANNELS_KEY, String(owner.getValue())));
    MicSource.recordGainDb.subscribe(owner => store(RECORD_GAIN_DB_KEY, String(owner.getValue())));
    MicSource.resolveDevice = () => {
        const id = MicSource.deviceId.unwrapOrUndefined();
        return AudioDevices.inputs.find(device => device.deviceId === id)
            ?? AudioDevices.defaultInput;
    };
    MicSource.label = () => {
        if (AudioDevices.inputs.length === 0) {
            return "Microfoon aan";
        }
        return MicSource.resolveDevice()?.label ?? "Microfoon aan";
    };
})(MicSource || (MicSource = {}));
